/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Heading_Combined_Continuity_SpottingInputs */

const en_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COMBINED CONTINUITY & SPOTTING LIST`)
};

const fr_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITE ET LISTE DE REPERAGE COMBINEES`)
};

const de_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KOMBINIERTE KONTINUITÄTS- UND SPOTTING-LISTE`)
};

const it_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA COMBINATA DI CONTINUITÀ E DI AVVISTAMENTO`)
};

const ru_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СВОДНЫЙ СПИСОК ПО СЛЕДУЮЩИМ ОБЗОРАМ И НАБЛЮДАНИЮ ЗА СИТУАЦИЕЙ`)
};

const es_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA COMBINADA DE CONTINUIDAD Y DETECTADO`)
};

const zh_cn2_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`综合连续性和定位列表`)
};

const ja_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連続性とスポッティングリストの組み合わせ`)
};

const hi_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संयुक्त निरंतरता और स्पॉटिंग सूची`)
};

const pt_pt2_ccsl_export_heading_combined_continuity_spotting = /** @type {(inputs: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA COMBINADA DE CONTINUIDADE E IDENTIFICAÇÃO`)
};

/**
* | output |
* | --- |
* | "COMBINED CONTINUITY & SPOTTING LIST" |
*
* @param {Ccsl_Export_Heading_Combined_Continuity_SpottingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_heading_combined_continuity_spotting = /** @type {((inputs?: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Heading_Combined_Continuity_SpottingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "de") return de_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "it") return it_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "ru") return ru_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "es") return es_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "ja") return ja_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "hi") return hi_ccsl_export_heading_combined_continuity_spotting(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_heading_combined_continuity_spotting(inputs)
	return en_ccsl_export_heading_combined_continuity_spotting(inputs)
});